import { HiCheckCircle, HiOutlineXCircle } from "react-icons/hi";
import { Card } from "./card";
export function ValueDisplay({
    title,
    value,
}: {
    title: string;
    value: string | undefined;
}) {
    return (
        <div className="flex flex-col items-center">
            <p className="text-xs font-medium">{title}</p>
            {value ? (
                <h2 className="text-2xl font-bold">{value}</h2>
            ) : (
                <span className="loading loading-bars loading-xl" />
            )}
        </div>
    );
}

export function ScoreDisplay({
    title,
    value,
    text,
    pass,
}: {
    title: string;
    value: string;
    text: string;
    pass: boolean;
}) {
    return (
        <Card>
            <div className="flex justify-between">
                <div className="flex flex-col items-start">
                    <p className="text-xs font-medium text-gray-600">{title}</p>
                    <h2 className="text-2xl font-bold">{value}</h2>
                    <p className="text-xs font-medium text-gray-600">{text}</p>
                </div>

                {pass ? (
                    <HiCheckCircle className="w-16 h-16 text-[#1F9735]" />
                ) : (
                    <HiOutlineXCircle className="w-16 h-16 text-[#ac2226]" />
                )}
            </div>
        </Card>
    );
}
